
// import React from 'react';
// import { FaImages, FaVideo } from 'react-icons/fa';
// import { BASE_URL } from '../BaseURL';
// import axios from 'axios';

// export default function Dashboarddata({ imageCount = 0, videoCount = 0 }) {
//   return (
//     <div className="container py-4">
//       <h2 className="mb-4 text-center">Gallery Summary</h2>
//       <div className="row justify-content-center">
        
//         {/* Total Images */}
//         <div className="col-md-4 mb-4">
//           <div className="card shadow-md border-1 p-3">
//             <div className="d-flex align-items-center">
//               <FaImages size={40} className="text-info me-3" />
//               <div>
//                 <h5 className="mb-1">Total Images</h5>
//                 <h4>{imageCount}</h4>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Total Videos */}
//         <div className="col-md-4 mb-4">
//           <div className="card shadow-md border-1 p-3">
//             <div className="d-flex align-items-center">
//               <FaVideo size={40} className="text-danger me-3" />
//               <div>
//                 <h5 className="mb-1">Total Videos</h5>
//                 <h4>{videoCount}</h4>
//               </div>
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// }






import React, { useEffect, useState } from 'react';
import { FaImages, FaVideo } from 'react-icons/fa';
import { BASE_URL } from '../BaseURL';
import axios from 'axios';

export default function Dashboarddata() {
  const [imageCount, setImageCount] = useState(0);
  const [videoCount, setVideoCount] = useState(0);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/gallery/counts`);
        if (res.data.success) {
          setImageCount(res.data.data.imageCount);
          setVideoCount(res.data.data.videoCount);
        }
      } catch (error) {
        console.error('Error fetching gallery counts:', error);
      }
    };

    fetchCounts();
  }, []);

  return (
    <div className="container py-4">
      <h2 className="mb-4 text-center">Gallery Summary</h2>
      <div className="row justify-content-center">
        
        {/* Total Images */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-md border-1 p-3">
            <div className="d-flex align-items-center">
              <FaImages size={40} className="text-info me-3" />
              <div>
                <h5 className="mb-1">Total Images</h5>
                <h4>{imageCount}</h4>
              </div>
            </div>
          </div>
        </div>

        {/* Total Videos */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-md border-1 p-3">
            <div className="d-flex align-items-center">
              <FaVideo size={40} className="text-danger me-3" />
              <div>
                <h5 className="mb-1">Total Videos</h5>
                <h4>{videoCount}</h4>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}


